<template>
  <Form :model="formItem" :label-width="80">
    <Row>
      <Col span="5">
      <FormItem label="查询内容">
        <Input v-model="formItem.content" :maxlength="searchTextMaxlength" class="common-width" clearable placeholder="请输入查询内容"  />
        <Input placeholder="" clearable style="width: 200px;display: none;" />
      </FormItem>
      </Col>
      <Col span="5" :style="{paddingLeft:formItem.msgPadLeft}">
      <!--    <ValidMessage :msg="currentMsg"></ValidMessage> -->
      </Col>
    </Row>
    <!-- 注释于2019.08.19,注释原因：所有引擎取消时间查询条件,改为在二次检索结果中输入时间 -->
   <!--  <FormItem label="时间范围">
      <Row>
        <Col span="10">
        <DatePicker type="daterange" format="yyyy.MM.dd" placement="bottom-end" style="width: 250px" placeholder="成文/解读时间范围" v-model="formItem.da" @on-change="timeOnChange"></DatePicker>
        </Col>
      </Row>
    </FormItem> -->
    <FormItem label="文件效力">
      <SingleSelect class="common-width" :tData="sTreeData" @onClearText="onForceClearText" @tag-Select="getForceSelection"></SingleSelect>
      <!--     <ButtonGroup>
        <Button v-for="item in formItem.fileforce" :type="item.type" :key="item.key" @click="ButtonGroupSelect(item.id)">{{item.value}}</Button>
      </ButtonGroup> -->
    </FormItem>
    <FormItem>
      <Button type="primary" icon="ios-search" size="default" @click="Submit">查询</Button>
    </FormItem>
  </Form>
</template>
<script>
import ValidMsg from './../valid_message.vue'
import TreeSingleselect from '../../common/tree-single-select.vue'
import treeData2 from '../../../assets/json/select-tree2.json'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
var vMsg = {
  countryValid: {
    success: ["success", "匹配成功"],
    falure: ["error", "未匹配到相关国家或地区"],
    warning: ["warning", "匹配中"],
  }
}
export default {
  name: 'globalform',
  data() {
    return {
      formItem: {
        content: "",
        fileforce:{},
        da:[],
        msgPadLeft: "0px"
      },
      currentMsg: vMsg.countryValid.warning,
      sTreeData: this.getSelectTreeData(),
      searchTextMaxlength:100,
    }
  },
  components: {
    'ValidMessage': ValidMsg,
    'SingleSelect': TreeSingleselect,
  },
  computed: {
    ...mapGetters(['sliderLength', 'sliderScreen', 'sta', 'countryData', 'isLogin'])
  },
  methods: {

    setSmallPadLeft() {
      this.formItem.msgPadLeft = "200px";
    },
    ...mapMutations([
      'screenSet'
    ]),
    Submit() {
      if (this.sliderLength >= 2) {
        this.screenSet(true);
      }
      // var st=this.getFormattedDate(this.formItem.data[0])
      // var et=this.getFormattedDate(this.formItem.data[1])
      // var newformatdata=[st,et]

      //console.log(this.formItem.da)

      this.$emit('onGlobalSearch', this.formItem)
      //console.log(this.formItem)
      //this.expand();

    },
    propDataInit(data, placeholder, searchable) {
      var a = {}
      a.data = data
      a.placeholder = placeholder
      a.searchable = searchable
      return a
    },
    getForceSelection(node) {
      this.formItem.fileforce = node
    },
    getFormattedDate(date) {
      var year = date.getFullYear();
      var month = (1 + date.getMonth()).toString();
      month = month.length > 1 ? month : '0' + month;
      var day = date.getDate().toString();
      day = day.length > 1 ? day : '0' + day;
      return year + '-' + month + '-' + day;
    },
    timeOnChange() {
      var time = []
      if (this.formItem.da[0] !== "") {
        time[0] = this.getFormattedDate(this.formItem.da[0])
        time[1] = this.getFormattedDate(this.formItem.da[1])
        this.formItem.da=time
      }else{

      }
    },
    onForceClearText() {
      this.formItem.fileforce = {}
    },
    getSelectTreeData() {
      return treeData2.force
    },
    resetSearchCondition(){
    }
  },
  mounted() {
    
  },
  watch: {
    countryData: function() {
      // let obj=this.propDataInit(this.sta.initData.country,"选择国家",true)
      // this.$refs.countrySelector.bindData(obj)
      //this.bindCountry()
    }
  },
}

</script>
<style scoped>
.common-width {
  width: 300px;
}

</style>
